import styled from "styled-components";
import { Form } from "react-bootstrap";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem;
  > div {
    margin: 1rem 0;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 1rem;
`;

export const Label = styled.div`
  font-size: 18px;
  margin-bottom: 5px;
  font-weight: 500;
`;

export const StyledFormGroup = styled(Form.Group)`
  margin-bottom: 1.5rem;
`;

export const StyledFormControl = styled(Form.Control)<{ hasError?: boolean }>`
  border-color: ${props => (props.hasError ? "#dc3545" : "")};
  &:focus {
    border-color: ${props => (props.hasError ? "#dc3545" : "")};
    box-shadow: ${props => (props.hasError ? "0 0 0 0.2rem rgba(220,53,69,.25)" : "")};
  }
`;

export const ErrorText = styled.div`
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
`;

export const HelpText = styled.div`
  color: #6c757d;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  margin-left: 1.5rem;
`;

export const TranslationWrapper = styled.div`
  width: 100%;

  /* Override the WitLabel style from TranslationComponent to match our Label style */
  > div > div:first-child {
    font-size: 18px;
    font-weight: 500;
  }

  /* Specific styles for the translation widget in BrandManager */
  .card {
    width: 100%;
    min-width: 1650px;
  }

  .card-header {
    padding: 0.75rem 1rem;
  }

  .form-label {
    display: none;
  }

  .nav-tabs {
    border-bottom: 1px solid #dee2e6;
  }

  .nav-tabs .nav-link {
    padding: 0.5rem 1rem;
    border: 1px solid transparent;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .nav-tabs .nav-link:hover {
    border-color: #e9ecef #e9ecef #dee2e6;
  }

  .nav-tabs .nav-link.active {
    color: #495057;
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff;
  }

  .card-body {
    padding: 1.25rem;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  .form-group col {
    margin-left: 0px !important;
  }

  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    margin-left: 0px !important;
  }
`;
